/**
 * Useful user-related properties
 */
import {i18n} from '@netx/core/i18n';

export let test = 'testString';

export let types = {
	// TODO: https://jira.netx.net/browse/DAM-8541
	0: i18n.t('i18n.userLevel0'), // No access
	1: i18n.t('i18n.userLevel1'), // Browser
	2: i18n.t('i18n.userLevel2'), // Consumer
	3: i18n.t('i18n.userLevel3'), // Importer
	4: i18n.t('i18n.userLevel4'), // Producer
	//5: "User Level 5",
	//6: "User Level 6",
	7: i18n.t('i18n.userLevel7'), // Manager
	8: i18n.t('i18n.userLevel8'), // Director
	9: i18n.t('i18n.userLevel9'), // Admin
};

export let userSource = {
	INTERNAL: 0,
	LDAP: 1,
	SAML: 2,
	PING_ONE: 3,
	LIVE_CONNECT: 4,
	NETX: 5,
};

export let groupErrors = {
	3008: i18n.t('i18n.errorGroupSelfRemovalWithFilter_3008'),
	default: i18n.t('i18n.error'),
};

export default {test, types, userSource};
